import React from 'react';
import {classes, stylesheet} from 'typestyle';
import {spinner} from './../styles/style';
import {LightGreyColor, GreyColor, WhiteColor, WhiteColorFaded10, BlackColorFaded05} from '../styles/colors';

export interface FFDropdownListItem {
    text: string;
    value: string;
}

interface FFDropdownListProps {
    listItems: FFDropdownListItem[];
    selectedValue: string;
    selectedValueChanged: (newValue: string) => void;
    isLoading?: boolean;
    width?: number;
    className?: string;
}

export default class FFDropdownList extends React.Component<FFDropdownListProps, {}> {
    private getListItems() {
        return this.props.listItems.map((item) => (
            <option key={item.value + item.text} value={item.value}>
                {item.text}
            </option>
        ));
    }

    public render() {
        return (
            <div className={classes(ffCss.select, this.props.className)}>
                <select
                    style={{width: this.props.width}}
                    onChange={(e) => this.props.selectedValueChanged(e.currentTarget.value)}
                    value={this.props.selectedValue}>
                    {this.getListItems()}
                </select>
                {this.props.isLoading ? <div className={spinner(20)} /> : null}
            </div>
        );
    }
}

const ffCss = stylesheet({
    select: {
        position: 'relative',
        color: GreyColor,
        background: WhiteColorFaded10,
        border: '1px solid ' + LightGreyColor,
        pointerEvents: 'all',
        $nest: {
            '& select': {
                appearance: 'none',
                border: 'none',
                borderRadius: '0',
                height: 32,
                paddingLeft: 5,
                backgroundColor: WhiteColor,
            },
            '&:disabled': {
                background: BlackColorFaded05,
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/views/FFDropdownList.tsx